import {FAILED_AUTH_INDEX} from '@web-catalog/const/numbers';

import {useAuthorizedProfile} from '@web-catalog/store/auth';

import {emitYmEvent, logTmrEvent} from '@web-catalog/utils/analytics/logEvent';

export const useAuthAnalytics = () => {
  const userInfo = useAuthorizedProfile();
  const logAuthorizationDone = () => {
    logTmrEvent({
      logEvent: 'authorizationDone',
      params: {
        vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
        authorization_source: 'vk_id',
        autologin: 'true',
      },
    });

    emitYmEvent({
      eventName: 'authorizationDone',
    });
  };

  const logAuthorizationAutologinError = (errorText: string) => {
    logTmrEvent({
      logEvent: 'authorization.AutologinError',
      params: {
        vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
        error_type: errorText,
      },
    });

    emitYmEvent({
      eventName: 'authorization_AutologinError',
    });
  };

  const logAuthorizationBannerShow = () => {
    logTmrEvent({
      logEvent: 'authorizationBanner.show',
      params: {vk_id: userInfo?.id ?? -1},
    });

    emitYmEvent({
      eventName: 'authorizationBanner_show',
    });
  };

  const logAuthorizationBannerUserAgreementClick = () => {
    logTmrEvent({
      logEvent: 'authorizationBanner.userAgreement.click',
      params: {vk_id: userInfo?.id ?? -1},
    });
  };

  const logAuthorizationHeaderClick = () => {
    logTmrEvent({
      logEvent: 'header.click',
      params: {
        vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
        button_text: 'profile_icon',
      },
    });
  };

  const logAuthorizationMenuProfileIconClick = () => {
    logTmrEvent({
      logEvent: 'menu.profileIcon.click',
      params: {vk_id: userInfo?.id ?? -1},
    });
  };

  return {
    logAuthorizationDone,
    logAuthorizationAutologinError,
    logAuthorizationBannerShow,
    logAuthorizationBannerUserAgreementClick,
    logAuthorizationHeaderClick,
    logAuthorizationMenuProfileIconClick,
  };
};
